module.exports = __webpack_public_path__ + "img/drc.2a881e81.svg";